import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


import DownloadIcon from '@mui/icons-material/Download';
import { Button, Grid, TextField } from '@mui/material'
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc'
import timezone from 'dayjs-timezone-iana-plugin';


const SangatTable = (props) => {
  const { rowData, selectRowCallback, columnDefs, flagLateEntryRow } = props;

  const [gridApi, setGridApi] = React.useState(null);
  const [gridColumnApi, setGridColumnApi] = React.useState({});
  const [quickFilterText, setQuickFilterText] = React.useState(null);


  dayjs.extend(utc);
  dayjs.extend(timezone);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }

  const onBtExport = () => {
    var today = new Date();
    gridApi.exportDataAsCsv({ fileName: today + 'version.csv', prependContent: 'Export Generated On:' + today });
  };


  React.useEffect(() => {
    if(gridApi) {
      //only search after the user has stopped typing, else some rows don't display
    const delayDebounceFn = setTimeout(() => {
      gridApi.setQuickFilter(
        quickFilterText
        );
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }
  }, [quickFilterText])

  const selectionChanged = (event) => {
    let selectedNodes = gridApi.getSelectedNodes();
    if (selectedNodes.length > 0) {
      selectRowCallback(selectedNodes[0].data)
    }
  }

  const getRowStyle  = (params) => {
    if (flagLateEntryRow && params.data.user_ride_from_airport === "YES" && (Math.abs(dayjs().diff(dayjs(params.data.user_arrivingFlightDate + " " + params.data.user_arrivingFlightTime + "+05:30"), "hour")) <= 48) && (Math.abs(dayjs(params.data.user_arrivalUpdatedAt).diff(dayjs(params.data.user_arrivingFlightDate + " " + params.data.user_arrivingFlightTime + "+05:30"), "hour")) <= 48) && (dayjs().isBefore(dayjs(params.data.user_arrivingFlightDate + " " + params.data.user_arrivingFlightTime + "+05:30")))) {
        return {'background-color': '#cc333344'}
    }
    return null;
}

  return (
    <React.Fragment>
      <Grid container sx={{ mb: 1, mt: 1 }}
        spacing={2}
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center">
        <Grid item >

          <TextField size="small" onChange={(e) => setQuickFilterText(e.target.value)} label="Search" variant="outlined" />
        </Grid>
        <Grid item>Total Sangat: {rowData && rowData.length > 0 ? rowData.length : 0}</Grid>
        <Grid item >
          <Button variant="outlined" onClick={() => onBtExport()} startIcon={<DownloadIcon />}>
            Download
          </Button>
        </Grid>
      </Grid>
      <div className="ag-theme-alpine" style={{ height: '400px' }}>
        <AgGridReact
           getRowStyle={getRowStyle} onSelectionChanged={selectionChanged} rowData={rowData} columnDefs={columnDefs} onGridReady={onGridReady} rowSelection="single" paginationPageSize="25" >
        </AgGridReact>
      </div>
    </React.Fragment>
  )


}
export default SangatTable;